import { get, post } from '@/utils/apiBase.js';
// 获取项目信息
const getProjectInfo = option => {
    return get('/apis/product/get_project_info', option)
}
// 判断各步骤数据是否全部填写完毕
const getProjectSubmitStatus = option => {
    return get('/apis/product/get_project_submit_status', option)
}
// 初始化实名认证状态
const initAuthStatus = option => {
    return get('/apis/user_auth_account/init_auth_status', option)
}
// 视频相关
const showVideoList = option => {
    return post('/api/v1/show_video_list', option)
}
// 个人愿望发起，获取项目状态
const getProjectActions = option => {
    return get('/apis/product/get_project_actions', option)
}
// 个人愿望创建--base
const Create = option => {
    return post('/pm/create', option)
}
// 个人愿望创建--base
const checkRewardTimeline = option => {
    return post('/pm/check_reward_timeline', option)
}
// 个人愿望创建--base
const editBase = option => {
    return post('/pm/edit_base', option)
}
// 个人愿望创建--base
const getBase = option => {
    return get('/initiate/edit_base', option)
}
// 添加登记行为记录信息
const addRegisterRecordInfo = option => {
    return post('/apis/pabank/add_register_record_info', option)
}
// 检测用户账户登记行为
const checkRegisterRecordInfo = option => {
    return get('/apis/pabank/check_register_record_info', option)
}
const getDetail = option => {
    return get('/initiate/edit_detail', option)
}
const editDetail = option => {
    return post('/pm/edit_detail', option)
}
// 回报档列表
const rewardList = option => {
    return get('/initiate/reward_list', option)
}
// 回报档编辑页详情
const rewardDetail = option => {
    return get('/initiate/reward_detail', option)
}
// 创建回报档
const addReward = option => {
    return post('/pm/add_reward', option)
}
// 编辑回报档
const editReward = option => {
    return post('/pm/edit_reward', option)
}
// 删除回报档
const deleteReward = option => {
    return post('/apis/product/delete_reward', option)
}
// 回报档排序
const sortReward = option => {
    return post('/pm/sort_reward', option)
}
// 提交审核
const submitAudit = option => {
    return post('/pm/submit_audit', option)
}
export default {
    getProjectInfo,
    getProjectSubmitStatus,
    initAuthStatus,
    showVideoList,
    getProjectActions,
    Create,
    checkRewardTimeline,
    editBase,
    getBase,
    addRegisterRecordInfo,
    checkRegisterRecordInfo,
    getDetail,
    editDetail,
    rewardList,
    rewardDetail,
    addReward,
    editReward,
    deleteReward,
    sortReward,
    submitAudit
}
